import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {DirectivesModule} from '../../directives/directives.module'
import {DynamicFormComponent} from './dynamic-form.component'
import {NumberInputModule} from '../../../craft/forms/number-input/number-input.module'
import {DynamicFormSummaryComponent} from './dynamic-form-summary/dynamic-form-summary.component'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {ReactiveFormsModule} from '@angular/forms'
import {TranslocoModule} from '@ngneat/transloco'
import {SelectModule} from '../../../craft/forms/select/select.module'
import {CheckboxModule} from '../../../craft/forms/checkbox/checkbox.module'
import {RadioModule} from '../../../craft/forms/radio/radio.module'
import {FormsModule} from '../../../craft/forms/forms.module'
import {PipesModule} from '../../pipes/pipes.module'
import {FormSummaryItemComponent} from '../form-summary-item/form-summary-item.component'

@NgModule({
  declarations: [DynamicFormComponent, DynamicFormSummaryComponent],
  exports: [DynamicFormComponent, DynamicFormSummaryComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslocoModule,
    DirectivesModule,
    FontAwesomeModule,
    NumberInputModule,
    SelectModule,
    CheckboxModule,
    RadioModule,
    FormsModule,
    PipesModule,
    FormSummaryItemComponent,
  ],
})
export class DynamicFormModule {}
